var colorComponentJS = (function() {

    function init(component) {
        let windowWidth = $(window).width();
        let inner = component.find('.inner');
        let card = component.find('.color-card');
        inner.removeClass('smaller-color-block');
        inner.removeClass('medium-color-block');
        inner.removeClass('vertical-color-block');
        card.removeClass('vertical-color-block');
        if (windowWidth >= 960) {
            let containerWidth = component.parent().width();
            if (containerWidth < 420) {
                inner.addClass('vertical-color-block');
                card.addClass('vertical-color-block');
            } else if (containerWidth < 580) {
                inner.addClass('smaller-color-block');
            } else if (containerWidth < 760) {
                inner.addClass('medium-color-block');
            }
        }
    }
    return {
        init: init
    }
})();

window.colorComponentJS = colorComponentJS;

export default colorComponentJS;

$(document).ready(function() {
    $(window).resize(function() {
        $('.color-card-component').each(function() {
            colorComponentJS.init($(this))
        });
    });
});